import { Component, _decorator } from 'cc';
import { Unit } from '../../../../../common/scripts/Account';
import NumberFormatter from '../../../../../common/scripts/Toolkit/Components/Label/NumberFormatter';
import Lobby from '../../../../System/Lobby';
import UnitSwitcher from './UnitSwitcher';

const { ccclass, requireComponent, property } = _decorator;

@ccclass('BindUnitNumber')
@requireComponent(NumberFormatter)
export default class BindUnitNumber extends Component {
    @property
    private readonly displayDollarSign: boolean = false;

    private _numberFormatter: NumberFormatter = null;

    private get numberFormatter() {
        if (!this._numberFormatter) {
            this._numberFormatter = this.getComponent(NumberFormatter);
        }
        return this._numberFormatter;
    }

    protected onEnable() {
        Lobby.event.on(UnitSwitcher.EVENT_DISPLAY_UNIT_CHANGED, this._onDisplayUnitChanged, this);
        this._onDisplayUnitChanged();
    }

    protected onDisable() {
        Lobby.event.off(UnitSwitcher.EVENT_DISPLAY_UNIT_CHANGED, this._onDisplayUnitChanged, this);
    }

    private _onDisplayUnitChanged() {
        if (UnitSwitcher.unit === Unit.Dollar) {
            // eslint-disable-next-line no-template-curly-in-string
            this.numberFormatter.textTemplate = this.displayDollarSign ? '${0}' : '';
            this.numberFormatter.specficCurrencyUnit = Unit.Dollar;
        } else {
            this.numberFormatter.textTemplate = '';
            this.numberFormatter.specficCurrencyUnit = Unit.Credit;
        }
        this.numberFormatter.updateTextDisplay();
    }
}
